import tw from "twin.macro"
import { Link } from "../../atoms/Link"
import { useContext } from "react"
import useTealiumEvent from "../../../hooks/Tealium/useTealiumEvent"
import { LanguageContext } from "../../../contexts/Language"
import { DisclaimersContext } from "../../../contexts/Disclaimers"
import { Image } from "../../atoms/Image"
import { parseDisclaimerBlocks, slugify } from "../../../helpers"
import { toggleDisclaimersModal } from "../../../contexts/Disclaimers/actions"
import { ArticleCardProps } from "./ArticleCard.d"
import Icon from "../../atoms/Icon"

const ArticleCard: React.FC<ArticleCardProps> = ({
  article,
  selectedParts = null,
  index,
}) => {
  const { _, language } = useContext(LanguageContext)
  const showPart = selectedParts?.includes(article?.part?.name) || false

  // Tealium
  const { trackTealEvent } = useTealiumEvent()
  const [state, modalDispatch] = useContext(DisclaimersContext)
  return (
    <article
      arial-label="Article"
      css={[tw`text-lg col-span-1`, tw`lg:(text-lg)`]}
    >
      <div css={[tw`flex flex-col  w-full gap-3  lg:gap-5`]}>
        <Link
          to={`/${article?.route?.slug?.current}`}
          className="group"
          css={[tw`relative text-sm w-full`]}
          onClick={() => {
            trackTealEvent({
              tealium_event: "article_click",
              link_href: `/${article?.route?.slug?.current}`,
              coupon_module_text: article?.title,
            })
          }}
          analytics-id={`article:articles:${index + 1}`}
        >
          <Image
            transparentPreview
            imageData={article?.featuredImage?.image}
            css={[tw`w-full h-full object-scale-down object-cover`]}
          />
        </Link>
        <div css={[tw`flex flex-col gap-1`]}>
          <Link
            to={`/${article?.route?.slug?.current}`}
            className="group"
            css={[tw`relative text-sm w-full`]}
            onClick={() => {
              trackTealEvent({
                tealium_event: "article_click",
                link_href: `/${article?.route?.slug?.current}`,
                coupon_module_text: article?.title,
              })
            }}
            analytics-id={`article:articles:${index + 1}`}
          >
            <h2
              css={[
                tw`text-xl font-semibold w-full hover:(underline) active:(text-toyotaRed no-underline) lg:(text-3xl)`,
              ]}
            >
              {parseDisclaimerBlocks(article?.title, selection =>
                modalDispatch(toggleDisclaimersModal(selection)),
              )}
            </h2>
          </Link>
          <Link
            to={`/${article?.route?.slug?.current}`}
            className="group"
            css={[tw`relative text-sm w-fit font-semibold`]}
            onClick={() => {
              trackTealEvent({
                tealium_event: "article_click",
                link_href: `/${article?.route?.slug?.current}`,
                coupon_module_text: article?.title,
              })
            }}
            animated
            animatedThin
            analytics-id={`article:articles:${index + 1}`}
          >
            {_("Read Article")}
            <Icon.Chevron
              css={[tw`h-2.5 inline-flex ml-1 justify-center text-red-400`]}
            />
          </Link>
        </div>
      </div>
    </article>
  )
}
export default ArticleCard
